/**
 * Event handles/names that should not be treated as actual events.
 * These are top-level app routes (e.g., /stays/:id, /travel/*) that happen to have a similar URL structure to event routes.
 *
 * Used by:
 * - AuthProvider.utils.tsx (useEventNameMatch) - prevents GetMe query with these as eventName
 * - EventRoute.tsx - prevents BasicEventInfo query with these as eventHandle
 */
export const EXCLUDED_EVENT_HANDLES: ReadonlySet<string> = new Set(['stays', 'travel']);
